module.exports = __webpack_public_path__ + "img/mind_skeleton_21.7265aa87.png";